// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorEscalationManager = (client) => ({
    /**
     * `POST /vendor/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorEscalationManagerCreate
     * @source packages/modules/b2c-core/src/api/vendor/escalation-manager/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/escalation-manager", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorEscalationManagerDelete
     * @source packages/modules/b2c-core/src/api/vendor/escalation-manager/route.ts
     */
    delete: (body, query, headers) => client.fetch("/vendor/escalation-manager", { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorEscalationManagerList
     * @source packages/modules/b2c-core/src/api/vendor/escalation-manager/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/escalation-manager", { method: "GET", query, headers }),
});
//# sourceMappingURL=escalation-manager.js.map